export function generateSampleCode(initials) {
  const n = new Date();
  const pad = v => String(v).padStart(2, '0');
  return `${pad(n.getHours())}${pad(n.getMinutes())}${pad(n.getSeconds())}` +
         `${pad(n.getDate())}${pad(n.getMonth() + 1)}${n.getFullYear()}` +
         `-${initials || 'XX'}`;
}
